export default "__VITE_ASSET__EQgTX0iR__"